<script setup>
defineProps({
  value: String,
  size: {
    type: String,
    default: 'md',
    validator: (value) => ['xs', 'sm', 'md', 'lg', 'xl'].includes(value)
  }
});
</script>

<template>
  <label :class="[
    'block font-medium text-gray-700',
    {
      'text-xs leading-4 tracking-tight': size === 'xs',
      'text-sm leading-5': size === 'sm',
      'text-base leading-6': size === 'md',
      'text-lg leading-7 tracking-wide': size === 'lg',
      'text-xl leading-8 tracking-wide': size === 'xl'
    }
  ]">
    <span v-if="value">{{ value }}</span>
    <span v-else><slot></slot></span>
  </label>
</template>